<template>
  <div class="body">
    <div style="margin-top: 0vh;">
      <el-form
          ref="form"
          :model="params"
          class="form"
          label-width="80px">
        <el-form-item label="开始时间" prop="startTime" style="float: left">
          <el-date-picker
              v-model="params.startTime"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"
              style="width:125px"
              type="date"
              placeholder="选择日期"/>
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime" style="float: left">
          <el-date-picker
              v-model="params.endTime"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              style="width:125px"
              type="date"
              placeholder="选择日期"/>
        </el-form-item>
        <el-form-item label="产线" prop="productType" style="float: left">
          <el-select v-model="params.productType" placeholder="请选择" @change="typeChange">
            <el-option
                v-for="item in materialTypeList"
                :key="item.pkid"
                :label="item.materialTypeName"
                :value="item.pkid"/>
          </el-select>
        </el-form-item>
        <!--        <el-form-item label="检验类型" prop="productType" style="float: left;margin-left: 5px">-->
        <!--          <el-select v-model="params.productType" placeholder="请选择" style="width: 100px;">-->
        <!--            <el-option label="首检" :value="30"/>-->
        <!--            <el-option label="巡检" :value="50"/>-->
        <!--            <el-option label="来料检" :value="10"/>-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
        <el-form-item label="查询方式" prop="queryType" style="float: left;margin-left: 5px">
          <el-select v-model="params.queryType" placeholder="请选择" style="width: 100px;">
            <el-option label="日" :value="0"/>
            <el-option label="周" :value="1"/>
            <el-option label="月" :value="2"/>
            <el-option label="年" :value="3"/>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="float: left; margin-left: 5px;">
        <el-button @click="params=$options.data().params">清空</el-button>
        <el-button :loading="submitLoading" type="primary" @click="getList">查询</el-button>
        <!--        <el-button :loading="exportLoading" type="success" @click="exportExcel">导出</el-button>-->
      </div>
    </div>
    <div style="margin-top: 7vh">
      <div style="width: 15%;float: left">
        <table class="table-left">
          <tr v-for="(item,index) in model.leftNames" :key="index">
            <td>
              <div class="cycleName">
                {{ item }}
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div style="width: 80%; overflow-x: scroll;">
        <table v-if="model.columns.length>0" class="table-right">
          <tr>
            <td v-for="(item,index) in model.cycleNames" :key="index">
              <div class="cycleName">
                {{ item }}
              </div>
            </td>
          </tr>
          <!--          <tr v-for="(item,index) in model.columns[0]" :key="index">-->
          <!--            <td>{{ item.valueCol }}</td>-->
          <!--          </tr>-->
          <tr v-for="(item,index) in model.rows" :key="index">
            <td v-for="(item1,index1) in item" :key="index1">
                        <span>
                            {{ item1.valueCol }}
                          </span>

            </td>
          </tr>
        </table>
        <table v-else class="table-right">
        </table>
      </div>
      <work-order-detail-list ref="workOrderDetailList"/>
    </div>
  </div>
</template>

<script>
import constant from "@/util/constant";
import dateUtil from "@/util/dateUtil";
import WorkOrderDetailList from "@/views/Report/ProductReport/WorkOrderDetailList";

export default {
  name: "ProcessRpt",
  components: {
    WorkOrderDetailList,
  },
  data() {
    return {
      constant,
      submitLoading: false,
      exportLoading: false,
      pickerOptions: {
        disabledDate: time => {
          return this.dealDisabledDate(time);
        },
      },
      params: {
        startTime: "",
        endTime: "",
        productType: "",
        productTypeName: "",
        queryType: 0,
        searchType: 0,
      },
      model: {
        columns: [],
        cycleNames: [],
        leftNames: [],
      },
      materialTypeList: [],
      maxPunctuality: "",
    };
  },
  mounted() {
    this.getMaterialTypeList();
  },
  methods: {
    getMaterialTypeList() {
      this.$http.get("basic", "materialTypes/getAllList").then((res) => {
        if (res.success) {
          this.materialTypeList = res.data;
        }
      });
    },
    typeChange(id) {
      this.params.productTypeName = this.materialTypeList.find(s => s.pkid === id).materialTypeName;
    },
    getList() {
      if (!this.params.startTime || !this.params.endTime) {
        this.$message.error("请设置查询参数");
        return;
      }
      this.submitLoading = true;
      this.$http
          .get("basic", "processRpt/workOrderPunctualityReport_V1", this.params)
          .then((res) => {
            console.log(res);
            this.model = res.data;
            this.maxPunctuality = Math.max.apply(Math, this.model.map(function(item) {
              return item.punctuality;
            }));
            this.submitLoading = false;
            // this.$message.success("获取成功");
          })
          .catch(() => {
            this.submitLoading = false;
            // this.$message.error("获取失败");
          });
    },
    //计算单元格时间段
    getStartAndEndDate(item, index) {
      let startTime = "";
      let endTime = "";
      let startDay = "";
      let oneWeekTime = 1000 * 60 * 60 * 24 * 7;
      let monday = new Date();
      let sunday = new Date();
      let month = "";
      let weekNum = 0;
      let EndDate = "";
      let nowDay = "";
      if (this.model.length === (index + 1)) {
        endTime = this.params.endTime;
      }
      switch (this.params.queryType) {
        case 0:
          startTime = item.cycleName;
          endTime = item.cycleName;
          break;
        case 1:
          startDay = new Date(item.cycleName.slice(0, 4) + "/01/01");
          monday = new Date(item.cycleName.slice(0, 4) + "/01/01");
          sunday = new Date(item.cycleName.slice(0, 4) + "/01/01");
          nowDay = startDay.getDay() || 7;
          monday = monday.setDate(startDay.getDate() - nowDay + 1);
          sunday = sunday.setDate(startDay.getDate() - nowDay + 7);
          weekNum = parseInt(item.cycleName.slice(5, 7));
          monday = monday + oneWeekTime * (weekNum - 1);
          sunday = sunday + oneWeekTime * (weekNum - 1);
          startTime = index ? dateUtil.format(new Date(monday), "yyyy-MM-dd") : this.params.startTime;
          if (new Date(startTime).getTime() < new Date(this.params.startTime).getTime()) {
            startTime = this.params.startTime;
          }
          endTime = endTime ? endTime : dateUtil.format(new Date(sunday), "yyyy-MM-dd");
          if (new Date(endTime).getTime() > new Date(this.params.endTime).getTime()) {
            endTime = this.params.endTime;
          }
          break;
        case 2:
          startTime = index ? item.cycleName.slice(0, 7) + "-01" : this.params.startTime;
          month = parseInt(this.model[index].cycleName.slice(5, 7)) + 1;
          month = month > 12 ? (month - 12) + "" : month + "";
          EndDate = endTime ? "" : this.model[index + 1].cycleName.slice(0, 4) + "/" + month + "/01";
          EndDate = endTime ? "" : new Date(EndDate).getTime() - (1000 * 60 * 60 * 24);
          endTime = endTime ? endTime : dateUtil.format(new Date(EndDate), "yyyy-MM-dd");
          break;
        case 3:
          startTime = index ? item.cycleName.slice(0, 4) + "-01-01" : this.params.startTime;
          endTime = endTime ? endTime : item.cycleName.slice(0, 4) + "-12-31";
          break;
        default:
          break;
      }
      let timeList = {
        startTime: startTime,
        endTime: endTime,
      };
      return timeList;
    },

    getPlanPosted(item, num, index) {
      var params = this.getStartAndEndDate(item, index);
      this.$refs.workOrderDetailList.open(params.startTime, params.endTime, num, this.params.productType, this.params.queryType, this.params.searchType);
    },
    //导出
    exportExcel() {
      this.exportLoading = true;
      this.$http
          .exportFile("basic", "productReports/workOrderPunctualityReportExport", this.params, 60 * 10000)
          .then(res => {
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
    },
    dealDisabledDate(time) {
      return (
          // time.getTime() > new Date((new Date().getTime() - 24 * 60 * 60 * 1000)).getTime()
          time.getTime() > new Date((new Date().getTime())).getTime()
      );
    },
    dialogClose() {
    },
  },
};
</script>
<style lang="scss" scoped>
.body {
  //height: 160vh;

  .table-left {
    width: 100%;
    border-top: 1px solid #ddd;
    border-left: 1px solid #ddd;
    border-collapse: collapse;

    tr {
      td {
        font-size: 15px;
        text-align: center;
        border-right: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
        padding: 10px 0;
        font-weight: bold;
      }
    }
  }

  .table-right {
    border-top: 1px solid #ddd;
    border-left: 0;
    border-collapse: collapse;

    tr {
      td {
        font-size: 15px;
        text-align: center;
        border-right: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
        padding: 10px 0;

      }

      td .cycleName {
        width: 95px;
      }
    }
  }

  .vm-main .vm-main-page {
    background-color: #fff;
  }

  .shipmentRate {
    width: 60%;
    /*margin: 0 auto 5px auto;*/
    background: #2D8CF0;
    position: absolute;
    bottom: 0;
    left: 20%;
  }
}
</style>
